import { ButtonLink } from '@semcore/ui/button';
import Tooltip from '@semcore/ui/tooltip';
import { useTranslation } from 'react-i18next';

export const ResearchFormDisabledFileUpload = () => {
  const { t } = useTranslation(['mailings', 'common']);

  return (
    <div className="flex gap-1">
      <Tooltip
        className="w-fit"
        title={t(
          'mailings:personalizedMailingCreatorWizard.objectivesForm.fileUpload.disabledTooltip',
        )}>
        <ButtonLink
          disabled
          data-test="disabled-upload-document-link"
          size={300}
          use="primary">
          {t(
            'mailings:personalizedMailingCreatorWizard.objectivesForm.research.researchLink.uploadDocument',
          )}
        </ButtonLink>
      </Tooltip>
      {t('common:or')}
      <Tooltip
        className="w-fit"
        title={t(
          'mailings:personalizedMailingCreatorWizard.objectivesForm.research.researchLink.selectResourceDisabledTooltip',
        )}>
        <ButtonLink
          disabled
          data-test="disabled-select-from-workspace-button"
          size={300}
          use="primary">
          {t(
            'mailings:personalizedMailingCreatorWizard.objectivesForm.research.researchLink.selectFromWorkspace',
          )}
        </ButtonLink>
      </Tooltip>
    </div>
  );
};
